import Api from './api';

const RenunciaReceitaService = {

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/renunciareceita/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/renunciareceita/buscar?${params}`)
        return response
    }
}

export default RenunciaReceitaService;